import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import cx from 'classnames';
import {
  Link, Button,
} from '@resy/ui-kitchen';

import {
  DATE_TIMEFORMAT, TIMEZONE_EST, BUYOUT_STATE_UPCOMING, BUYOUT_STATE_THIS_WEEKS, BUYOUT_STATE_PAST,
} from '../../constants';
import currentTimeParserWithTimezone from '../../currentTimeParserWithTimezone';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import './AmexShopSmallBuyoutTabs.scss';

class AmexShopSmallBuyoutTabs extends React.Component {
  static propTypes = {
    buyoutConfig: PropTypes.shape({
      buyout_mappings: PropTypes.arrayOf(PropTypes.shape({})),
      past_drops_label: PropTypes.string,
      this_weeks_drops_label: PropTypes.string,
      upcoming_drops_label: PropTypes.string,
      header: PropTypes.string,
      content: PropTypes.string,
      content_link: PropTypes.shape({
        asterisk: PropTypes.string, copy: PropTypes.string, link: PropTypes.string,
      }).isRequired,
      current_upcoming_buyout_text: PropTypes.string,
      past_buyout_text: PropTypes.string,
    }).isRequired,
    getVenueDetails: PropTypes.func.isRequired,
    Analytics: PropTypes.shape({ event: PropTypes.func.isRequired }).isRequired,
    taggingConfig: PropTypes.shape({
      buyout_selector: PropTypes.shape({
        buyout_pill_click_event: PropTypes.string,
      }),
    }).isRequired,
    scrollTo: PropTypes.func.isRequired,
    toggleTerms: PropTypes.func.isRequired,
  }

    state = {
      pastBuyoutArr: [],
      upComingBuyoutArr: [],
      thisWeeksBuyoutArr: [],
      selectedBuyout: {},
      selectedBuyoutCode: '',
    }

    componentDidMount() {
      const {
        buyoutConfig: {
          buyout_mappings: buyoutMappings,
        },
      } = this.props;
      this.calculateBuyouts(buyoutMappings);
    }

    findDefaultBuyoutObjectWithState = (pastBuyoutArr, thisWeeksBuyoutArr, upComingBuyoutArr) => {
      let defaultBuyoutObject = {};
      let defaultBuyoutState = '';

      if (thisWeeksBuyoutArr.length > 0) {
        [defaultBuyoutObject] = thisWeeksBuyoutArr;
        defaultBuyoutState = BUYOUT_STATE_THIS_WEEKS;
      } else if (upComingBuyoutArr.length > 0) {
        [defaultBuyoutObject] = upComingBuyoutArr;
        defaultBuyoutState = BUYOUT_STATE_UPCOMING;
      } else if (pastBuyoutArr.length > 0) {
        [defaultBuyoutObject] = pastBuyoutArr;
        defaultBuyoutState = BUYOUT_STATE_PAST;
      }

      const defaultBuyout = {
        ...defaultBuyoutObject,
        buyoutState: defaultBuyoutState,
      };

      this.setState({ selectedBuyout: defaultBuyout, selectedBuyoutCode: defaultBuyoutObject.code });
      return defaultBuyout;
    }

    findSelectedBuyoutObjectWithState = (selectedBuyoutCode) => {
      const {
        pastBuyoutArr, thisWeeksBuyoutArr, upComingBuyoutArr,
      } = this.state;

      if (!selectedBuyoutCode) {
        return null;
      }
      let buyoutState = '';
      let buyoutObject = {};

      const pastBuyout = pastBuyoutArr.find((o) => o.code === selectedBuyoutCode);
      const thisWeeksBuyout = thisWeeksBuyoutArr.find((o) => o.code === selectedBuyoutCode);
      const upComingBuyout = upComingBuyoutArr.find((o) => o.code === selectedBuyoutCode);

      if (thisWeeksBuyout) {
        buyoutState = BUYOUT_STATE_THIS_WEEKS;
        buyoutObject = thisWeeksBuyout;
      } else if (upComingBuyout) {
        buyoutState = BUYOUT_STATE_UPCOMING;
        buyoutObject = upComingBuyout;
      } else if (pastBuyout) {
        buyoutState = BUYOUT_STATE_PAST;
        buyoutObject = pastBuyout;
      }

      const selectedBuyout = {
        ...buyoutObject,
        buyoutState,
      };

      this.setState({ selectedBuyout, selectedBuyoutCode });
      return selectedBuyout;
    }

    calculateBuyouts = (buyoutMappings) => {
      const pastBuyoutArr = [];
      const upComingBuyoutArr = [];
      const thisWeeksBuyoutArr = [];

      const orderedBuyouts = buyoutMappings.sort((a, b) => a.id - b.id);
      orderedBuyouts.map((item) => {
        const {
          // eslint-disable-next-line camelcase
          buyout_start_date, buyout_end_date,
        } = item;

        const parseCurrentDateinEST = currentTimeParserWithTimezone(TIMEZONE_EST);
        const parsedEndDate = moment(buyout_end_date, DATE_TIMEFORMAT);
        const parsedStartDate = moment(buyout_start_date, DATE_TIMEFORMAT);

        if (parseCurrentDateinEST.isAfter(parsedEndDate)) {
          pastBuyoutArr.push(item);
        }

        if (parseCurrentDateinEST.isSameOrBefore(parsedEndDate) && parseCurrentDateinEST.isSameOrAfter(parsedStartDate)) {
          thisWeeksBuyoutArr.push(item);
        }

        if (parseCurrentDateinEST.isBefore(parsedEndDate) && parseCurrentDateinEST.isBefore(parsedStartDate)) {
          upComingBuyoutArr.push(item);
        }
        return null;
      });

      this.setState({ pastBuyoutArr, thisWeeksBuyoutArr, upComingBuyoutArr });
      const defaultBuyout = this.findDefaultBuyoutObjectWithState(pastBuyoutArr, thisWeeksBuyoutArr, upComingBuyoutArr);
      const { getVenueDetails } = this.props;
      getVenueDetails(defaultBuyout);
    }

    renderBuyoutButton = (item) => {
      const {
        selectedBuyoutCode, loading,
      } = this.state;

      const {
        Analytics, taggingConfig: {
          buyout_selector: {
            buyout_pill_click_event: buyoutPillClickEventName,
          },
        },
      } = this.props;

      const { getVenueDetails } = this.props;
      return (
        <Button
          variant="no-style"
          type="button"
          {...(selectedBuyoutCode === item.code ? { 'aria-current': 'page' } : {})}
          {...loading === true ? { disabled: true } : ''}
          className={cx('AmexShopSmallBuyoutTabs__buyoutpanel__button', {
            selectedbuyout: (selectedBuyoutCode === item.code),
          })}
          onClick={() => {
            const selectedBuyout = this.findSelectedBuyoutObjectWithState(item.code);
            getVenueDetails(selectedBuyout);
            Analytics.event(buyoutPillClickEventName, {
              category: 'Shop Small Interaction',
              context: 'Shop Small Page',
            });
            this.setFocus();
          }}
          key={item.code}
        >
          {item.label}
        </Button>

      );
    }

    renderBuyoutButtonPanel = (buyoutArray, label, timing) => (
      <li
        className="AmexShopSmallBuyoutTabs__item"
        aria-labelledby={timing}
      >
        <div role="group">
          <h3 className="AmexShopSmallBuyoutTabs__label" id={timing}>{label}</h3>
          {buyoutArray && buyoutArray.map((item) => this.renderBuyoutButton(item))}
        </div>
      </li>
    );

    setFocus = () => {
      const searchResults = document.querySelector('.AmexShopSmallBuyoutTabs__fineprint');
      if (searchResults) {
        searchResults.focus();
      }
      return false;
    }

    renderDropContent = () => {
      const {
        buyoutConfig: {
          current_upcoming_buyout_text: currentUpcomingBuyoutText,
          past_buyout_text: pastBuyoutText,
        },
      } = this.props;

      const {
        selectedBuyout,
      } = this.state;

      const { buyoutState } = selectedBuyout;
      let dynamicContent = '';
      if (buyoutState !== BUYOUT_STATE_PAST) {
        const { label } = selectedBuyout;
        dynamicContent = `${currentUpcomingBuyoutText} ${label}`;
      } else {
        dynamicContent = pastBuyoutText;
      }
      const sanitizedDynamicContent = sanitizeString(dynamicContent);

      const classes = [
        'AmexShopSmallBuyoutTabs__fineprint',
        buyoutState === BUYOUT_STATE_PAST && 'past',
      ].filter(Boolean).join(' ');
      return (
        <div className={classes} role="status" tabIndex="-1">
          <p
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitizedDynamicContent,
            }}
          />
        </div>
      );
    };

     handleScroll = (url) => {
       const { toggleTerms, scrollTo } = this.props;
       const currentHash = url.replace('#', '');
       toggleTerms(currentHash);
       setTimeout(() => {
         scrollTo(url);
       }, 500);
     };

     render() {
       const {
         pastBuyoutArr, upComingBuyoutArr, thisWeeksBuyoutArr,
       } = this.state;

       const {
         buyoutConfig: {
           // eslint-disable-next-line camelcase
           past_drops_label, this_weeks_drops_label, upcoming_drops_label, header, content,
           content_link: {
             asterisk, copy, link,
           },
         },
       } = this.props;

       const sanitizedContent = sanitizeString(content);

       return (
         <div className="AmexShopSmallBuyoutTabs__section">
           <h2 className="AmexShopSmallBuyoutTabs__title">{header}</h2>
           <div className="AmexShopSmallBuyoutTabs__content">
             <div
                // eslint-disable-next-line react/no-danger
               dangerouslySetInnerHTML={{
                 __html: sanitizedContent,
               }}
             />
             <p className="AmexShopSmallBuyoutTabs__contentLink">
               <span>{asterisk}</span>
               <Link
                 className="AmexShopSmallBuyoutTabs__link"
                 key={copy}
                 href={link}
                 variant="no-style"
                 onClick={() => { this.handleScroll(link); }}
               >
                 {copy}
               </Link>
             </p>
           </div>
           <nav
             className="AmexShopSmallBuyoutTabs__buyoutpanel"
             aria-label="Buyout Participating restaurants"
           >
             <ul className="AmexShopSmallBuyoutTabs__items">
               {pastBuyoutArr.length > 0 && this.renderBuyoutButtonPanel(pastBuyoutArr, past_drops_label, BUYOUT_STATE_PAST)}
               {thisWeeksBuyoutArr.length > 0 && this.renderBuyoutButtonPanel(thisWeeksBuyoutArr, this_weeks_drops_label, BUYOUT_STATE_THIS_WEEKS)}
               {upComingBuyoutArr.length > 0 && this.renderBuyoutButtonPanel(upComingBuyoutArr, upcoming_drops_label, BUYOUT_STATE_UPCOMING)}
             </ul>
           </nav>
           {this.renderDropContent()}
         </div>

       );
     }
}

export default AmexShopSmallBuyoutTabs;
